import { render, staticRenderFns } from "./CsTablePaginationContainer.vue?vue&type=template&id=43c805d0&"
import script from "./CsTablePaginationContainer.vue?vue&type=script&setup=true&lang=js&"
export * from "./CsTablePaginationContainer.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports